import Timeline from "../components/Timeline";

const TimelinePage = (p) => {
  return <Timeline />;
};
export default TimelinePage;
